export default __webpack_public_path__ + "static/media/concacaf.c6f31f4f.svg";